import { connect } from 'react-redux';

import SearchAutocomplete from '../../components/ConsumerHeader/SearchAutocomplete';
import {
    searchAutocompleteSuggestions as searchAutocompleteSuggestionsAction,
    searchFilterAction,
} from '../../pages/home/redux/search/';
import { trackFeedEvent } from '../../pages/home/redux/app';

const _mapStateToProps = (state) => ({
    suggestions: state.suggestions,
    locationSlug: state.location.slug,
});

const _mapDispatchToProps = {
    onSearchSuggestionChange: searchAutocompleteSuggestionsAction,
    handleApplyFilter: searchFilterAction,
    trackGAEvent: trackFeedEvent,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(SearchAutocomplete);
